<template>
  <div>
    <div class="modal-box">
      <header class="modal-card-head">
        <span class="modal-card-title">Add new member</span>
        <button
          class="delete"
          aria-label="close"
          @click="close"
        />
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <label class="label">First Name</label>
              <p class="control">
                <input
                  v-model="member.first"
                  class="input"
                  type="text"
                  placeholder="First"
                >
              </p>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">Middle Name</label>
              <p class="control">
                <input
                  v-model="member.middle"
                  class="input"
                  type="text"
                  placeholder="Middle"
                >
              </p>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">Last Name</label>
              <p class="control">
                <input
                  v-model="member.last"
                  class="input"
                  type="text"
                  placeholder="Last"
                >
              </p>
            </div>
          </div>
        </div>
        <label class="label">Profile Picture</label>
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <p class="control">
                <vue-dropzone
                  id="dropzone"
                  ref="memberPhoto"
                  :options="dropzoneOptions"
                  @vdropzone-success="getMemberPhotoLink"
                />
              </p>
            </div>
          </div>
          <div
            class="column is-6"
            style="border-left:3px solid #545454; margin-left:15px;"
          >
            <div
              class="field"
              style="padding-left:25px;"
            >
              <p class="control">
                <img
                  v-if="member.memberphoto"
                  :src="member.memberphoto"
                >
              </p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">Poker Nickname</label>
              <p class="control">
                <input
                  v-model="member.handle"
                  class="input"
                  type="text"
                  placeholder="Poker Nickname"
                >
              </p>
            </div>
          </div>
        </div>
        <hr>
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">E Mail</label>
              <p class="control">
                <input
                  v-model="member.email"
                  class="input"
                  type="text"
                  placeholder="Email"
                >
              </p>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Phone</label>
              <p class="control">
                <input
                  v-model="member.phone"
                  class="input"
                  type="text"
                  placeholder="Phone"
                >
              </p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-12">
            <div class="field">
              <label class="label">Street</label>
              <p class="control">
                <input
                  v-model="member.street"
                  class="input"
                  type="text"
                  placeholder="Full Address"
                >
              </p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <label class="label">City</label>
              <p class="control">
                <input
                  v-model="member.city"
                  class="input"
                  type="text"
                  placeholder="City"
                >
              </p>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">State</label>
              <p class="control">
                <input
                  v-model="member.state"
                  class="input"
                  type="text"
                  placeholder="State"
                >
              </p>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">ZIP</label>
              <p class="control">
                <input
                  v-model="member.zip"
                  class="input"
                  type="text"
                  placeholder="ZIP"
                >
              </p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-12">
            <div class="field">
              <label class="checkbox">
                <input type="checkbox">
                Send "Welcome" E-mail
              </label>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-12">
            <div class="field">
              <label class="checkbox">
                <input type="checkbox">
                E-mail updates requested
              </label>
            </div>
          </div>
        </div>

        <div class="field">
          <div class="control">
            <span class="errorMessage">{{ errorMessage }}</span>
            <a
              type="submit"
              class="button button-tools"
              @click.prevent="create"
            >
              Create
            </a>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<style scoped>
  .errorMessage {
    color: red;
    display: block;
    padding-bottom: 20px;
    font-weight: bold;
  }
</style>
<script>
  import axios from 'axios'
  import vueDropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'

  export default {
    name: 'ToolsMembersCreate',
    components: {
      vueDropzone
    },
    props: ['token', 'user'],
    data() {
      return {
        errorMessage: '',
        member: {
          first: '',
          middle: '',
          last: '',
          handle: '',
          city: '',
          state: '',
          zip: '',
          street: '',
          email: '',
          phone: '',
          memberphoto: '',
        },
        dropzoneOptions: {
          url: '//rest.ahlpoker.com/image/upload/members',
          thumbnailWidth: 150,
          maxFilesize: 10,
          paramName: 'file',
          acceptedFiles: 'image/*',
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560'
          },
          success: (file, res) => {
            if (file.previewElement) {
              return file.previewElement.classList.add('dz-success')
            }
            JSON.parse(res).link
          }
        },
      }
    },
    methods: {
      getMemberPhotoLink(file, res) {
        this.member.memberphoto = res.link
        this.$refs.memberPhoto.removeAllFiles()
      },
      create() {
        let data = {...this.member}
        Object.assign(data, {token: this.token})
        this.$axios({
          method: 'POST',
          url: 'admin/members/addmember',
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            if (!res.data.error) {
              this.$emit('message',
                {
                  showDialog: true,
                  error: false,
                  message: 'Member has been created'
                })
              data.ahlid = res.data.ahlid
              this.$emit('addMemberId', data)
            } else {
              this.$emit('message',
                {
                  showDialog: true,
                  error: true,
                  message: res.data.message
                })
              this.errorMessage = res.data.message
            }
          })
          .catch((error) => {
            this.$emit('message',
              {
                showDialog: true,
                error: true,
                message: error.response.data.message
              })
          })
      },
      close() {
        this.$emit('close')
      }
    }
  }
</script>
